
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row mt-2">
    <div class="col-12">
      <success #success></success>
    </div>
    <div class="col-12" *ngIf="enableCostCenters &amp;&amp; customerChanged">
      <div class="alert alert-danger">
        <p>Customer BP ID changed. Cost Center Information must be updated if previously applied.</p>
      </div>
    </div>
    <div class="col">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter project details:</p>
      </div>
    </div>
  </div>
  <form #projectForm="ngForm">
    <div class="row justify-content-md-center mb-3">
      <div class="col-md-10 card-block">
        <div class="m-2">
          <div class="row">
            <div class="form-group col-lg-6">
              <label class="required" for="name">Project Name:</label>
              <input class="form-control" id="name" type="text" [(ngModel)]="project.name" name="projectName" maxlength="40" required>
              <validation-error-display [error]="error" field="projectName"></validation-error-display>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6" *appSetting="'allowSettingUniqueId'">
              <label for="opportunityId">Opportunity ID:</label>
              <input class="form-control" id="opportunityId" [(ngModel)]="project.opportunityId" name="opportunityId" type="text">
              <validation-error-display [error]="error" field="opportunityId"></validation-error-display>
            </div>
            <div class="form-group col-lg-6" *appSetting="'allowSettingUniqueId'">
              <label for="uniqueId">Unique ID:</label>
              <input class="form-control" id="uniqueId" [(ngModel)]="project.uniqueId" name="uniqueId" type="text">
              <validation-error-display [error]="error" field="uniqueId"></validation-error-display>
            </div>
          </div>
          <div class="row" style="margin-bottom: -1rem">
            <div class="form-group col-lg-6">
              <label class="required" for="customerName">Reseller/{{ targetSystem === 'mimp' || targetSystem === 'pmpsp' || targetSystem === 'pmps-st' || targetSystem === 'mpflexr' ? 'Sold-To' : 'Vendor'}} {{ !enableTaxNumberSearch ? 'Name' : null}}</label>
            </div>
          </div>
          <div class="row" *ngIf="enableTaxNumberSearch" style="margin-top:-0.9rem;margin-left: -0.5rem">
            <div class="col-lg-2" style=" font-size: 14px;margin-right: -0.8rem;">Search By:</div>
            <div class="form-group col-lg-9" style="margin-left:-2.9rem;">
              <input class="form-check-input" type="radio" autoLinkToLabel [disabled]="resellerState === 1 || resellerSet" [value]="name" name="resellerSearchType" (click)="checkResellerSearchBy('name')" [checked]="resellerSearchBy == 'name'">
              <label class="form-check-label" style="font-size:12px">Name</label>
              <input class="form-check-input" type="radio" name="resellerSearchType" autoLinkToLabel [disabled]="resellerState === 1 || resellerSet" style="margin-left: 1rem" [value]="bpid" (click)="checkResellerSearchBy('bpid')" [checked]="resellerSearchBy == 'bpid'">
              <label class="form-check-label" style="font-size:12px;margin-left: 2.1rem;">BPID</label>
              <input class="form-check-input" type="radio" name="resellerSearchType" autoLinkToLabel [disabled]="resellerState === 1 || resellerSet" style="margin-left: 1rem" [value]="taxNumber" (click)="checkResellerSearchBy('taxNumber')" [checked]="resellerSearchBy == 'taxNumber'">
              <label class="form-check-label" style="font-size:12px;margin-left: 2.1rem;">Tax Number</label>
            </div>
          </div>
          <div class="row" style="margin-top: -0.8rem;">
            <div class="form-group col-lg-6">
              <div class="input-group">
                <input class="form-control" id="resellerName" [disabled]="resellerState === 1  || customerState === 4 || resellerState === 5 || customerState === 5  || resellerSet" [(ngModel)]="project.resellerName" name="resellerName" type="text" maxlength="140" placeholder="{{resellerSearchBy==='name' &amp;&amp; enableTaxNumberSearch &amp;&amp; (targetSystem === 'mimp' || targetSystem === 'pmpsp' || targetSystem === 'pmps-st' || targetSystem === 'mpflexr') ? 'Enter Reseller/Sold-To Name': resellerSearchBy==='name' &amp;&amp; enableTaxNumberSearch ? 'Enter Reseller/Vendor Name': resellerSearchBy==='bpid' &amp;&amp; enableTaxNumberSearch &amp;&amp; (targetSystem === 'mimp' || targetSystem === 'pmpsp' || targetSystem === 'pmps-st' || targetSystem === 'mpflexr') ? 'Enter Reseller/Sold-To BPID' : resellerSearchBy==='bpid' &amp;&amp; enableTaxNumberSearch ? 'Enter Reseller/Vendor BPID' : resellerSearchBy==='taxNumber' &amp;&amp; enableTaxNumberSearch ? 'Enter Tax Number' : null }}" required>
                <div class="input-group-append">
                  <button class="btn btn-primary" id="searchResellerName" type="button" (click)="searchCustomerName(true)" [disabled]="!(project.resellerName || '').length || resellerState === 1 || resellerState === 5 || customerState === 5  || resellerSet">Go</button>
                </div>
              </div>
              <validation-error-display [error]="error" field="resellerName"></validation-error-display><a *ngIf="resellerState === 3 &amp;&amp; resellerErrorMessages !== null" style="color:red;" href="javascript:void(0);" (click)="showErrorMessages(false)">Error - See more details</a><span class="d-block" *ngIf="resellerState === 1 || resellerState === 4 || resellerState === 5" style="color: green;">{{ resellerMessage }}</span>
            </div>
            <div class="form-group col-lg-6" style="margin-top: -1.4rem;">
              <label>Reseller/{{ targetSystem === 'mimp' || targetSystem === 'pmpsp' || targetSystem === 'pmps-st' || targetSystem === 'mpflexr' ? 'Sold-To' : 'Vendor'}} BP ID:</label>
              <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.resellerBpId}}&nbsp;</span></div>
            </div>
          </div>
          <div class="row" style="margin-bottom: -1rem">
            <div class="form-group col-lg-6">
              <label class="required" for="customerName">{{ targetSystem === 'pmpsp' || targetSystem === 'pmps-st' || targetSystem === 'mimp' || targetSystem === 'mpflexr' ? 'End Customer' : 'Sold-To'}} {{ !enableTaxNumberSearch ? 'Name' : null}}</label>
            </div>
          </div>
          <div class="row" *ngIf="enableTaxNumberSearch" style="margin-top:-0.9rem;margin-left: -0.5rem">
            <div class="col-lg-2" style=" font-size: 14px;margin-right: -0.8rem;">Search By:</div>
            <div class="form-group col-lg-9" style="margin-left:-2.9rem;">
              <input class="form-check-input" type="radio" autoLinkToLabel [disabled]="customerState === 1 || customerSet" [value]="name" name="customerSearchType" (click)="checkCustomerSearchBy('name')" [checked]="customerSearchBy == 'name'">
              <label class="form-check-label" style="font-size:12px">Name</label>
              <input class="form-check-input" type="radio" name="customerSearchType" autoLinkToLabel [disabled]="customerState === 1 || customerSet" style="margin-left: 1rem" [value]="bpid" (click)="checkCustomerSearchBy('bpid')" [checked]="customerSearchBy == 'bpid'">
              <label class="form-check-label" style="font-size:12px;margin-left: 2.1rem;">BPID</label>
              <input class="form-check-input" type="radio" name="customerSearchType" autoLinkToLabel [disabled]="customerState === 1 || customerSet" style="margin-left: 1rem" [value]="taxNumber" (click)="checkCustomerSearchBy('taxNumber')" [checked]="customerSearchBy == 'taxNumber'">
              <label class="form-check-label" style="font-size:12px;margin-left: 2.1rem;">Tax Number</label>
            </div>
          </div>
          <div class="row" style="margin-top: -0.8rem;">
            <div class="form-group col-lg-6">
              <div class="input-group">
                <input class="form-control" id="customerName" [disabled]="customerState === 1  || customerState === 4 || customerState === 5 || customerSet" [(ngModel)]="project.customerName" name="customerName" type="text" maxlength="140" placeholder="{{customerSearchBy==='name' &amp;&amp; enableTaxNumberSearch &amp;&amp; (targetSystem === 'pmpsp' || targetSystem === 'pmps-st' || targetSystem === 'mimp' || targetSystem === 'mpflexr')?  'Enter End Customer Name': customerSearchBy==='name' &amp;&amp; enableTaxNumberSearch ? 'Enter Sold-To Name' : customerSearchBy==='bpid' &amp;&amp; enableTaxNumberSearch &amp;&amp; (targetSystem === 'pmpsp' || targetSystem === 'pmps-st' || targetSystem === 'mimp' || targetSystem === 'mpflexr') ? 'Enter End Customer BPID': customerSearchBy==='bpid' &amp;&amp; enableTaxNumberSearch ? 'Enter Sold-To BPID' : customerSearchBy=='taxNumber' &amp;&amp; enableTaxNumberSearch ? 'Enter Tax Number' : null}}" required>
                <div class="input-group-append">
                  <button class="btn btn-primary" id="searchCustomerName" type="button" (click)="searchCustomerName()" [disabled]="!(project.customerName || '').length || customerState === 1 || customerState === 5  || customerSet">Go</button>
                </div>
                <button class="btn btn-primary ml-1" id="updateEndCustomerData" *ngIf="enableMS4CustomerRefresh" title="Click to refresh MS4 customer data to ITSM" type="button" (click)="updateEndCustomerData()" [disabled]="!(project.customerName || '') || customerState === 1 || customerState === 5 || customerState === 4 || !canUpdateEndCustomerData"><span class="icon oi oi-reload" [ngClass]="{'icn-spinner': spinRefreshMS4Button}"></span></button>
              </div>
              <validation-error-display [error]="error" field="customerName"></validation-error-display><a *ngIf="customerState === 3 &amp;&amp; customerErrorMessages !== null" style="color:red;" href="javascript:void(0);" (click)="showErrorMessages(true)">Error - See more details</a><span class="d-block" *ngIf="customerState === 1 || customerState === 4 || customerState === 5" style="color: green;">{{ customerMessage }}</span>
            </div>
            <div class="form-group col-lg-6" style="margin-top: -1.4rem;">
              <label>{{ targetSystem === 'pmpsp' || targetSystem === 'pmps-st' || targetSystem === 'mimp' || targetSystem === 'mpflexr' ? 'End Customer' : 'Sold-To'}} BP ID:</label>
              <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.customerBpId}}&nbsp;</span></div>
            </div>
          </div>
          <div class="row" *appSetting="'enableGlobalDeals'">
            <div class="form-group col-lg-6">
              <label class="required" for="customerOpportunityGroupName">Customer Opportunity Group:</label>
              <div class="input-group">
                <input class="form-control" id="opportunityGroupName" [(ngModel)]="globalDealSettings.customerOpportunityGroupName" name="customerOpportunityGroupName" type="text" maxlength="100" required [disabled]="!isPurgeMaster">
                <div class="input-group-append">
                  <button class="btn btn-primary" id="searchOpportunityGroupName" type="button" (click)="searchCustomerOpportunityGroup()" [disabled]="!!(!customerSet) || !isPurgeMaster">Go</button>
                </div>
              </div>
              <validation-error-display [error]="error" field="customerOpportunityGroupName"></validation-error-display><span class="d-block" *ngIf="!globalDealSettings.customerOpportunityGroupId &amp;&amp; cogCreationState === 1" style="color: green;">PENDING - COG is getting created in ITSM</span><span class="d-block" *ngIf="!globalDealSettings.customerOpportunityGroupId &amp;&amp; cogCreationState === 3" style="color: red;">{{cogCreationError}}</span>
            </div>
          </div>
          <div class="row" *appSetting="'enableIndirectDataModel'">
            <div class="form-group col-sm-6" *ngIf="showSelectFleetButton">
              <label class="required">Fleet Name:</label>
              <div class="input-group">
                <input class="form-control" [(ngModel)]="project.fleetName" name="fleetName" type="text" maxLength="255" (change)="updateFleetId()" [disabled]="newFleetName" required>
                <div class="input-group-append">
                  <button class="btn btn-primary" type="button" (click)="openFleetDialog()" *ngIf="showSelectFleetButton">Go</button>
                </div>
              </div>
            </div>
            <div class="form-group col-sm-6" *ngIf="showSelectFleetButton">
              <label class="required">Fleet ID:</label>
              <input class="form-control" [ngClass]="{'readonly-white underlined': lockFleetId}" [(ngModel)]="project.fleetId" [readonly]="lockFleetId" name="fleetId" type="text" maxLength="50" required>
            </div>
            <div class="form-group col-sm-6" *ngIf="!showSelectFleetButton">
              <label class="required">Fleet ID:</label>
              <input class="form-control" [ngClass]="{'readonly-white underlined': lockFleetId}" [(ngModel)]="project.fleetId" [readonly]="lockFleetId" name="fleetId" type="text" maxLength="50" required>
            </div>
            <div class="form-group col-sm-6" *ngIf="!showSelectFleetButton">
              <label class="required">Fleet Name:</label>
              <div class="input-group">
                <input class="form-control" [(ngModel)]="project.fleetName" name="fleetName" type="text" maxLength="255" (change)="updateFleetId()" [disabled]="newFleetName" required>
                <div class="input-group-append">
                  <button class="btn btn-primary" type="button" (click)="openFleetDialog()" *ngIf="showSelectFleetButton">Go</button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <label>Country:</label>
              <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.country.countryName}}&nbsp;</span></div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-12">
              <label class="required" for="sourceDocumentationLink">Source Documentation Link (DealSource or MAD):</label>
              <input class="form-control" id="sourceDocumentationLink" [(ngModel)]="project.sourceDocumentationLink" name="sourceDocumentationLink" type="text" required>
              <validation-error-display [error]="error" field="sourceDocumentationLink"></validation-error-display>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6">
              <div class="inline-block">
                <label class="required" for="startDate">Project Start Date:
                  <help-dialog-button fieldName="Start Date" helpString="The approved project start date (typically requires contract signature)"></help-dialog-button>
                </label>
              </div>
              <datepicker class="right input-group-append" [(ngModel)]="project.startDate" name="startDateSelector" (outputEvents)="startDateChange($event)" required showInput="startDate"></datepicker>
              <validation-error-display [error]="error" field="startDate"></validation-error-display>
            </div>
            <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="inline-block">
                <label for="customerKickoffDate">Customer Kickoff Date:</label>
              </div>
              <datepicker class="right input-group-append" [(ngModel)]="project.customerKickoffDate" name="customerKickoffDateSelector" [options]="completionDateOptions" required showInput="customerKickoffDate"></datepicker>
              <validation-error-display [error]="error" field="customerKickoffDate"></validation-error-display>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="inline-block">
                <label for="completionDate">Estimated Project Completion Date:
                  <help-dialog-button fieldName="Estimated Completion Date" helpString="The estimated date that all deployment deliverables will be completed for this customer project"></help-dialog-button>
                </label>
              </div>
              <datepicker class="right input-group-append" [(ngModel)]="project.estimatedCompletionDate" name="estimatedCompletionDateSelector" [options]="completionDateOptions" showInput="completionDate"></datepicker>
              <validation-error-display [error]="error" field="estimatedCompletionDate"></validation-error-display>
            </div>
            <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="inline-block">
                <label for="estimatedProjectClosureDate">Estimated Project Closure Date:</label>
              </div>
              <datepicker class="right input-group-append" [(ngModel)]="project.estimatedProjectClosureDate" name="estimatedProjectClosureDateSelector" [options]="completionDateOptions" showInput="estimatedProjectClosureDate"></datepicker>
              <validation-error-display [error]="error" field="estimatedProjectClosureDate"></validation-error-display>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6 col-xs-12">
              <div class="row m-0">
                <label class="required col-md-6 pl-0">Project Status:</label>
                <select class="form-control col-md-6" id="selectStatus" name="status" [(ngModel)]="project.status" autoLinkToLabel (change)="onStatusChange()" [disabled]="project.status === 'draft' || project.status === 'archived'">
                  <option value="open">Transition</option>
                  <option value="steady">Steady State</option>
                  <option value="hold">On Hold</option>
                  <option value="closed">Closed</option>
                  <ng-container *ngIf="project.status === 'draft'">
                    <option value="draft">Draft</option>
                  </ng-container>
                  <ng-container *ngIf="project.status === 'archived'">
                    <option value="archived">Archived</option>
                  </ng-container>
                </select>
                <validation-error-display [error]="error" field="status"></validation-error-display>
              </div>
            </div>
            <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="inline-block">
                <label *ngIf="project.status === 'closed'">Actual Project Closure Date:</label>
                <label class="text-secondary" *ngIf="project.status !== 'closed'"><i>Actual Project Closure Date:</i></label>
              </div>
              <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.actualProjectClosureDate}}&nbsp;</span></div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-lg-6 col-xs-12">
              <div class="row">
                <div class="col-md-6">
                  <label class="required" id="enableBulkOrderingLabel">Enable Bulk Ordering</label>
                </div>
                <div class="form-group col-md-6 col-xs-12 d-inline-flex pl-md-0">
                  <div class="form-check flex-grow-1">
                    <div class="d-block float-md-right">
                      <input class="form-check-input" type="radio" name="enableBulkOrdering" [(ngModel)]="project.enableBulkOrdering" autoLinkToLabel [value]="true">
                      <label class="form-check-label">Yes</label>
                    </div>
                  </div>
                  <div class="form-check flex-grow-1">
                    <div class="d-block float-md-right">
                      <input class="form-check-input" type="radio" name="enableBulkOrdering" [(ngModel)]="project.enableBulkOrdering" autoLinkToLabel [value]="false">
                      <label class="form-check-label">No</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-md-10 card-block">
        <div class="m-2">
          <div class="row mb-2">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-6" style="cursor: pointer;" (click)="toggleAdditional = !toggleAdditional">
                  <div class="mt-2">
                    <h5 class="float-left">Additional Information</h5><i class="float-left text-secondary">&nbsp;(optional)</i>
                  </div>
                </div>
                <div class="col-lg-6 text-right"><a class="nav-link" id="additionalInfoButtonOpen" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Hide additional information" *ngIf="toggleAdditional" (click)="toggleAdditional = false"><span class="icon oi oi-chevron-top"></span></a><a class="nav-link" id="additionalInfoButtonClose" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show additional information" *ngIf="!toggleAdditional" (click)="toggleAdditional = true"><span class="icon oi oi-chevron-bottom"></span></a></div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="toggleAdditional">
            <div class="row">
              <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
                <div class="row">
                  <div class="col-lg-6">
                    <label>First Install Date</label>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.firstInstallDate}}</span></div>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
                <div class="row">
                  <div class="col-lg-6">
                    <label>First Order Date</label>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.firstOrderDate}}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" *appSetting="'MSTT-87-SMARTSHEET-AND-DATES'">
              <div class="form-group col-lg-6">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label>Estimated Transition (months)</label>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group border-bottom">
                      <label class="text-muted">{{project.estimatedTransitionDate}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label>Actual Transition (months)</label>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group border-bottom">
                      <label class="text-muted">{{project.actualTransitionDate}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-lg-6">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label for="totalCustomerValue">Total Contract Value (USD)</label>
                  </div>
                  <div class="col-lg-6">
                    <input class="form-control" id="totalCustomerValue" [(ngModel)]="project.totalCustomerValue" name="totalCustomerValue" type="number">
                    <validation-error-display [error]="error" field="totalCustomerValue"></validation-error-display>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6 mt-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" name="requireMaiPagecounts" [(ngModel)]="project.requireMaiPagecounts" autoLinkToLabel>
                  <label class="form-check-label">Require MAI Initial Page Counts</label>
                  <validation-error-display [error]="error" field="requireMaiPagecounts"></validation-error-display>
                </div>
              </div>
              <div class="form-group col-lg-6" id="currency">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label>Currency</label>
                  </div>
                  <div class="col-lg-6">
                    <div class="input-group border-bottom"><span class="text-secondary pl-2">{{project.currency}}&nbsp;</span></div>
                    <validation-error-display [error]="error" field="currency"></validation-error-display>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <div class="row">
                  <div class="col-lg-6 my-auto">
                    <label for="customerPin">Customer PIN</label>
                  </div>
                  <div class="col-lg-6">
                    <input class="form-control" id="customerPin" [(ngModel)]="project.customerPin" name="customerPin" type="text" maxlength="20">
                    <validation-error-display [error]="error" field="customerPin"></validation-error-display>
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-6">
                <label for="sourceName">Source Name</label>
                <input class="form-control" id="sourceName" [(ngModel)]="project.sourceName" name="sourceName" type="text" maxlength="60">
                <validation-error-display [error]="error" field="sourceName"></validation-error-display>
              </div>
            </div>
            <div class="row mb-1">
              <div class="form-group col-lg-6">
                <label for="partnerPurchaseOrders">Partner Purchase Orders</label><span> (Add 1 per Line)</span>
                <textarea class="form-control" id="partnerPurchaseOrders" [(ngModel)]="partnerPurchaseOrders" name="partnerPurchaseOrders" rows="3"></textarea>
                <validation-error-display [error]="error" field="partnerPurchaseOrders"></validation-error-display>
              </div>
              <div class="form-group col-lg-6">
                <label for="partnerPurchaseOrders">Delivery Instructions For Every HWO</label>
                <textarea class="form-control" id="deliveryInformation" [(ngModel)]="project.deliveryInformation" name="deliveryInformation" rows="3"></textarea>
                <validation-error-display [error]="error" field="deliveryInformation"></validation-error-display>
              </div>
            </div>
            <div class="row mb-1">
              <div class="col-lg-6" *ngIf="enableCostCenters">
                <div>
                  <label>Cost Center Information</label>
                </div>
                <div class="btn-group">
                  <button class="btn btn-outline-primary dropdown-toggle mt-3" data-toggle="dropdown" type="button" [disabled]="!customerSet || isFileDownloading || !enableCostCenterFileDropdown">Cost Center File
                    <div class="dropdown-menu"><a class="dropdown-item" href="javascript:void(0)" [downloadFile]="'/api/cost-center/export-cost-center-file'" [params]="{projectId: projectId, customerId: project.itsmCustomerId}">Export Cost Center File</a><a class="dropdown-item" [uploadFileTo]="'/api/cost-center/import-cost-center-file'" [params]="{projectId: projectId, customerId: project.itsmCustomerId}" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Upload Cost Center File'">Import Cost Center File</a></div>
                  </button>
                </div>
              </div>
              <div class="form-group col-lg-6" *ngIf="!isFedLlcDomainFlag">
                <label>Export TMC Data to Smartsheet Workspace</label>
                <table class="table table-striped">
                  <tbody>
                    <tr *ngFor="let workspace of project.workspaces;">
                      <td>{{workspace.name}}</td>
                    </tr>
                  </tbody>
                </table>
                <button class="btn btn-outline-primary" id="selectSmartSheetButton" type="button" (click)="promptUserForSmartsheetWorkspaceId()">Select Smartsheet Workspace</button>
                <validation-error-display [error]="error" field="smartsheetWorkspace"></validation-error-display>
              </div>
            </div>
            <div class="row" *ngIf="enableCustomFields" style="margin-top: 15px;">
              <div class="col-lg-12">
                <div>
                  <label style="font-weight: bold;">Custom Labels</label>
                </div>
              </div>
              <div class="form-group col-lg-6" *ngFor="let field of customFields; let idx = index;">
                <label for="field">Custom Field Label {{idx+1}}</label>
                <input class="form-control" id="customLabel{{idx+1}}" [(ngModel)]="project[field]" name="{{field}}" type="text" maxlength="60">
                <validation-error-display [error]="error" field="{{field}}"></validation-error-display>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Fill out quality checklist:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center" *ngIf="project">
    <div class="col-md-10 card-block">
      <div class="m-2">
        <h5 class="mt-2">Installation Quality Checklist</h5>
        <list-display-v2 [listStructure]="qualityChecklistData"></list-display-v2>
      </div>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter installation instructions:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-md-10 card-block">
      <div class="m-2">
        <div class="mt-2 border-bottom">
          <h5>MAI Installation Instructions</h5>
          <list-display-v2 [listStructure]="maiInstructionsData"></list-display-v2>
        </div>
        <h5 class="mt-4">Lease Installation Instructions</h5>
        <list-display-v2 [listStructure]="leaseInstructionsData"></list-display-v2>
      </div>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Enter Dashboard data:</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-md-10 card-block">
      <div class="m-2">
        <div class="mt-2 border-bottom">
          <h5>Dashboard Milestones</h5>
          <list-display-v2 [listStructure]="milestoneData"></list-display-v2>
        </div>
        <h5 class="mt-4">Dashboard Issues</h5>
        <list-display-v2 [listStructure]="dashboardIssueData"></list-display-v2>
      </div>
    </div>
  </div>
</div>